function AdminName({ product }) {
  return <>{product ? product : "Loading..."}</>;
}

export default AdminName;
